<template>
  <div id="dadosGeraisOuvidoria">
    <b-card header-tag="header" class="m-3" no-body>
      <b-card-body>
        <b-row v-if="manifestacao">
          <b-col cols="12" md="6" xl="4">
            <b-form-group label="Nome do manifestante" label-class="text-left">
              <b-form-input
                v-if="nomeManifestante"
                disabled
                v-model="nomeManifestante"
                type="text"
              />
              <b-form-input v-else disabled placeholder="Não definido" />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group label="CPF do manifestante" label-class="text-left">
              <b-form-input
                disabled
                v-model="manifestacao.IdUsuarioManifestante"
                type="text"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group
              label="Data de criação da manifestação"
              label-class="text-left"
            >
              <b-form-datepicker
                disabled
                v-bind="datePickerProps"
                v-model="manifestacao.DataCriacao"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group label="Assunto" label-class="text-left">
              <b-overlay :show="loadingAssunto">
                <b-form-input disabled v-model="descAssunto" />
              </b-overlay>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group label="Status" label-class="text-left">
              <b-overlay :show="loadingStatus">
                <b-form-input disabled v-model="descStatus" />
              </b-overlay>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group
              label="Data de encerramento da manifestação"
              label-class="text-left"
            >
              <b-form-datepicker
                disabled
                v-bind="datePickerProps"
                v-model="manifestacao.DataEncerramento"
                :placeholder="manifestacao.DataEncerramento ?? 'Não definida'"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group
              label="Data de vencimento inicial da manifestação"
              label-class="text-left"
            >
              <b-form-datepicker
                disabled
                v-bind="datePickerProps"
                v-model="manifestacao.DataVencimentoInicial"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group
              label="Data de vencimento atualizada da manifestação"
              label-class="text-left"
            >
              <b-form-datepicker
                disabled
                v-bind="datePickerProps"
                v-model="manifestacao.DataVencimentoAtualizada"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group label="Protocolo do ETCE" label-class="text-left">
              <b-form-input
                disabled
                v-model="manifestacao.CodProtocoloEtce"
                type="text"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group label="Sigiloso" label-class="text-left">
              <b-form-select
                disabled
                v-model="manifestacao.Sigilo"
                :options="optionsSigilo"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="Mensagem" label-class="text-left">
              <b-form-input
                disabled
                v-model="manifestacao.Mensagem"
                type="text"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script lang="ts">
import ouvidoriaService from "@/services/administracao/ouvidoriaService";
import { DatePickerDefaultProps } from "@/types/form-default-props";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import { Manifestacao } from "@/types/administracao/ouvidoria/manifestacao";
import { SelectValue } from "@/types/select-value";

const CompProps = Vue.extend({
  name: "DadosGeraisOuvidoria",
  components: {},
  props: {
    manifestacao: {
      type: Manifestacao,
      required: true,
    },
    nomeManifestante: {
      type: String,
      required: true,
    },
  },
});

@Component
export default class DadosGeraisOuvidoria extends mixins(UtilsTS, CompProps) {
  datePickerProps = DatePickerDefaultProps;
  isBusy = true;
  descAssunto = "";
  descStatus = "";

  loadingAssunto = true;
  loadingStatus = true;

  optionsSigilo: SelectValue[] = [
    { value: "0", text: "Não" },
    { value: "1", text: "Sim" },
  ];

  async getAssunto() {
    try {
      this.loadingAssunto = true;
      const response = await ouvidoriaService.getAllAssunto();
      this.descAssunto = this.capitalize(
        response.find((a) => a.IdAssunto === this.manifestacao?.IdAssunto)
          ?.DescAssunto ?? ""
      );
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.loadingAssunto = false;
    }
  }

  async getStatus() {
    try {
      this.loadingStatus = true;
      const response = await ouvidoriaService.getAllStatus();
      this.descStatus = this.capitalize(
        response.find((s) => s.CodStatus === this.manifestacao?.CodStatus)
          ?.Status ?? ""
      );
    } catch (error: unknown) {
      this.tratarError(error);
    } finally {
      this.loadingStatus = false;
    }
  }

  async mounted(): Promise<void> {
    this.getAssunto();
    this.getStatus();
  }
}
</script>

<style scoped>
</style>